export const imagesContainer = {
  display: "flex",
  flexDirection: "row",
  gap: "10px",
};

export const imagesButton = {
  color: "primary",
  cursor: "pointer",
  fontFamily: "body",
  fontWeight: "light",
  fontSize: "14px",
  lineHeight: "18px",
  textAlign: "center",
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  borderColor: "text",
  display: "block",

  "&:hover,&:focus": {
    borderColor: "primary",
  },
};

export const image = ({ backgroundImageUrl, isSelected }) => {
  return {
    width: "80px",
    height: "80px",
    backgroundColor: "background",
    border: "1px solid transparent",
    borderColor: isSelected ? "primary" : "inherit",
    borderRadius: "1000px",
    margin: "0 0",
    backgroundImage: `url("${backgroundImageUrl}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "contain",
    boxShadow: isSelected ? "0px 5px 10px rgba(0, 0, 0, 0.125)" : "none",

    ":hover&, :focus&": {
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.125)",
    },
  };
};

export const changeViewIcon = {
  display: "block",
  margin: "10px 0 0",
};
